import { z } from 'zod';
export var PropertyTypeEnum;
(function (PropertyTypeEnum) {
    PropertyTypeEnum["SINGLE_FAMILY"] = "Single Family";
    PropertyTypeEnum["DUPLEX"] = "Duplex";
    PropertyTypeEnum["TRIPLEX"] = "Triplex";
    PropertyTypeEnum["FOURPLEX"] = "Fourplex";
})(PropertyTypeEnum || (PropertyTypeEnum = {}));
export var PropertyStatusEnum;
(function (PropertyStatusEnum) {
    PropertyStatusEnum["AVAILABLE"] = "available";
    PropertyStatusEnum["CONTRACTED"] = "contracted";
    PropertyStatusEnum["DELETED"] = "deleted";
    PropertyStatusEnum["DRAFT"] = "draft";
    PropertyStatusEnum["PENDING"] = "pending";
    PropertyStatusEnum["REMOVED"] = "removed";
    PropertyStatusEnum["SOLD"] = "sold";
})(PropertyStatusEnum || (PropertyStatusEnum = {}));
export const propertySchema = z.object({
    id: z.string(),
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    propertyClass: z.string().optional(),
    propertyStatus: z.enum(PropertyStatusEnum).optional(),
    photo: z.string().optional(),
    totalUnits: z.number().default(1),
    purchasePrice: z.number().optional(),
    propertyType: z.enum(PropertyTypeEnum).or(z.string()),
});
